
import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { Alert } from "@/addons/Alert";
import { useConsultorioStore } from '../../store/consultorioStore';
import { consultorioService } from '../../services/ConsultorioService';

@Component({
	name: "nuevaResina"
})
export default class nuevaResina extends Vue {
	@Prop() dialog!: boolean

	private consultorioStore = useConsultorioStore();
	private consultorioService = consultorioService.getInstance();

	resinaForm = {
		resina: '',
		industria: '',
	};

	valid = true;
	editar = 0;


	close() {
		this.limpiar();
		this.$emit("close");
	}
	guardar() {
		if (!this.$refs.form.validate()) {
			Alert.warning(`Lene todos los campos obligatorios (*)`)
			return;
		}

		Alert.confirm(`Se registrará la nueva resina ${this.resinaForm.resina}`, 'Nueva Resina').then(async result => {
			if (result.isConfirmed) {
				await this.consultorioService.nuevaResina(this.resinaForm)
				this.limpiar()
				this.$emit('close')
				this.$emit('listar')
			}
		})


	}

	limpiar() {
		this.resinaForm = {
			resina: '',
			industria: '',
		};
	}
	get loading(): boolean {
		return this.consultorioStore.loading;
	}

}
